import objectHash, { NormalOption } from "object-hash";
import { useEffect, useMemo } from "react";
import { useTicketData } from "./useTicketData";

type Props = {
  saveHash?: boolean;
  ticketId?: string;
};

export type TicketHashes = {
  [ticketId: string]: string;
};

export const useTicketUpdate = (config?: Props) => {
  const ticketData = useTicketData(config?.ticketId);
  const hash = useMemo(
    () => objectHash(ticketData, getTicketHashOptions()),
    [ticketData]
  );

  const savedHashes = useMemo(() => getTicketHashObject(), [ticketData]);

  useEffect(() => {
    if (config?.saveHash) setHashes();
  }, [hash]);

  function setHashes() {
    const newHashes = { ...savedHashes };
    newHashes[ticketData?.ticket?.id] = hash;
    setTicketHashObject(newHashes);
  }

  const hasUpdate = hash !== savedHashes[ticketData?.ticket?.id];

  return { hasUpdate };
};

export function getTicketHashKey() {
  return "ticket-hashes";
}

export function getTicketHashOptions(): NormalOption {
  return {
    respectType: false,
    unorderedArrays: true,
    unorderedSets: true,
    excludeKeys: (key) => key === "_objCount",
  };
}

export function getTicketHashObject(): TicketHashes {
  const itemRaw = window.localStorage.getItem(getTicketHashKey()) ?? "{}";
  const item = JSON.parse(itemRaw);
  return item;
}

export function setTicketHashObject(ticketHashes: TicketHashes) {
  window.localStorage.setItem(getTicketHashKey(), JSON.stringify(ticketHashes));
}
